import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Employer } from './employer.interface';

export class EmployerService {
   async getEmployers(params?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Employer>>>(`/employers`, { params });
      return response.data;
   }

   async getEmployer(employerId: number) {
      const response = await http.get<ApiResource<Employer>>(`/employers/${employerId}`);
      return response.data.data;
   }

   async postEmployer(employer: Employer) {
      const response = await http.post<ApiResource<Employer>>(`/employers`, employer);
      return response.data.data;
   }

   async putEmployer(employerId: number, employer: Employer) {
      const response = await http.put<ApiResource<Employer>>(`/employers/${employerId}`, employer);
      return response.data.data;
   }

   async deleteEmployer(employerId: number) {
      const response = await http.delete(`/employers/${employerId}`);
      return response.data;
   }

   async postEmployerLogo(employerId: number, logo: File) {
      const formData = new FormData();
      formData.append('logo', logo);

      const response = await http.post(`/employers/${employerId}/logo`, formData);
      return response.data.data;
   }
}
